﻿let $ = require('jquery');
let URI = require('urijs');
require('../jssocials.min.js');


module.exports = function ({ element, shareButton, sharePopup }) {
    element.find('.select-image').click(function () { selectImage($(this)); });
    element.find('#previousButton').click(previousImage);
    element.find('#nextButton').click(nextImage);
    
    $(document).click((e) => {
        if (shareButton.is(e.target)) {
            sharePopup.jsSocials('option', 'url', getShareUrl())
            sharePopup.show();
        } else {
            sharePopup.hide();
        }
    });
    
    //TODO add share url with specific image
    sharePopup.jsSocials({
        showLabel: false,
        showCount: false,
        shares: ["twitter", "facebook"]
    });

    function getShareUrl() {
        let index = parseInt($("#elementGallery").text())
        return URI(window.location).query(index ? { index } : {});
    }

    function selectImage(selectedImage) {
        var selectedSrcImage = $(selectedImage).attr('mainImg');
        var selectedIndex = $(selectedImage).attr('index');
        var images = $(".jnf-smugmug-event-gallery-images").children();

        viewMainImage(selectedIndex, selectedSrcImage);
        checkArrows(selectedIndex);
    }

    function viewMainImage(selectedIndex, selectedSrcImage) {
        $("#elementGallery").text(selectedIndex);
        $("#galleryMainImage").css("background-image", "url(" + selectedSrcImage + ")");
        $("#galleryMainImage").attr('index', selectedIndex);
    }

    function nextImage(selectedButton) {
        var previousIndex = parseInt($("#elementGallery").text());
        var images = $(".jnf-smugmug-event-gallery-images").children();
        let nextIndex = previousIndex + 1 < images.length ? previousIndex + 1 : images.length;
        nextIndex = padDigits(nextIndex, 2);
        var selectedImage = $(".jnf-smugmug-event-gallery-images img[index*='" + nextIndex + "']");
        selectImage(selectedImage);
    }

    function previousImage(selectedImage) {
        var previousIndex = parseInt($("#elementGallery").text());
        var images = $(".jnf-smugmug-event-gallery-images").children();
        let nextIndex = previousIndex - 1 > 0 ? previousIndex - 1 : 1;
        nextIndex = padDigits(nextIndex, 2);
        var selectedImage = $(".jnf-smugmug-event-gallery-images img[index*='" + nextIndex + "']");
        selectImage(selectedImage);
    }

    function checkArrows(imageIndex) {
        var images = $(".jnf-smugmug-event-gallery-images").children();
        if (imageIndex != images.length) {
            $("#nextButton").css("opacity", 1);
        }
        else {
            $("#nextButton").css("opacity", 0.5);
        }

        if (imageIndex > 1) {
            $("#previousButton").css("opacity", 1);
        }
        else {
            $("#previousButton").css("opacity", 0.5);
        }
    }

    function padDigits(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
    }
}